export enum FileStatus {
    pending = "pending",
    uploaded = "uploaded",
    unpublished = "unpublished",
    error = "error"
}
